import { EstateResultItem_OneViewCollectionInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  collection: EstateResultItem_OneViewCollectionInput;
  assignButton?: React.ReactNode;
  title: string;
  subtitle: string;
};

export default function CollectionAsset({
  id,
  showAssetBtn,
  collection,
  assignButton,
  title,
  subtitle,
}: Props) {
  return (
    <Asset
      key={id}
      id={id}
      showAssetBtn={showAssetBtn}
      assignButton={assignButton}
      itemData={[
        { field: 'Institution', value: collection.clientNameOrNumber },
        { field: 'Date Reported', value: collection.dateReported },
        { field: 'Date Assigned', value: collection.dateAssigned },
        { field: 'Original Amount', value: collection.originalAmount },
        { field: 'Balance', value: collection.balance },
        { field: 'Status', value: collection.status },
        { field: 'Date of Delinquency', value: collection.dateOfDelinquency },
        {
          field: 'Account Designator',
          value: collection.accountDesignatorCode,
        },
        {
          field: 'Creditor Classification',
          value: collection.creditorClassification,
        },
      ]}
      title={title}
      subtitle={subtitle}
    />
  );
}
